const ALERT = {
  SET_ALERT: 'SET_ALERT',
  CLEAR_ALERT: 'CLEAR_ALERT'
};

export default ALERT;
